/**
 * Split view content renderer for agent reports.
 */

import { FileTextIcon, Loader2Icon } from 'lucide-react'
import type { ReactNode } from 'react'

import { AgentReportHtmlContent } from '@/components/atoms/agent-report-html-content.atom'
import { cn } from '@/lib/utils'

import type { AgentReportData } from './agent-report.interface'

export interface AgentReportContentProps {
  data: AgentReportData
  className?: string
}

export const AgentReportContent: React.FC<AgentReportContentProps> = ({
  data,
  className,
}): ReactNode => (
  <div className={cn('agent-report-content flex h-full flex-col overflow-auto p-4', className)}>
    {data.content ? (
      <AgentReportHtmlContent html={data.content} />
    ) : data.isLoading ? (
      <div className="agent-report-loading flex flex-1 flex-col items-center justify-center gap-3 text-muted-foreground">
        <Loader2Icon className="size-6 animate-spin" />
        <span className="text-sm">Generating report...</span>
      </div>
    ) : (
      <div className="agent-report-empty flex flex-1 flex-col items-center justify-center gap-3 text-muted-foreground">
        <FileTextIcon className="size-6" />
        <span className="text-sm">No report content available</span>
      </div>
    )}
  </div>
)
